import type { HubChromeSet } from "../components/page/PersonaOpportunityHubChrome/hub-chrome.types.js";
import type { PersonaOpportunitySet } from "../types/persona-opportunities.types.js";

/**
 * Parent page (optimistic page 1) wins on duplicate ids. Either source can be first to
 * see a new set, so the merge re-sorts newest first to match the server order.
 */
export function mergeHubSets(
  parent: readonly PersonaOpportunitySet[],
  extra: readonly PersonaOpportunitySet[],
): HubChromeSet[] {
  const byId = new Map<string, HubChromeSet>();
  for (const set of parent) {
    byId.set(set.id, { ...set, sentCount: set.sentCount ?? 0 });
  }
  for (const set of extra) {
    if (!byId.has(set.id)) {
      byId.set(set.id, { ...set, sentCount: set.sentCount ?? 0 });
    }
  }
  return [...byId.values()].sort(compareNewestFirst);
}

function compareNewestFirst(left: HubChromeSet, right: HubChromeSet): number {
  const byCreatedAt = Date.parse(right.createdAt) - Date.parse(left.createdAt);
  if (byCreatedAt !== 0 && Number.isFinite(byCreatedAt)) return byCreatedAt;
  if (left.id === right.id) return 0;
  return left.id < right.id ? 1 : -1;
}
